<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("af:application.closed.title") }}
    </p>
    <application-template
      template="APPLICATION_IS_CLOSED"
    ></application-template>
    <b-button
      id="flowClosedButtonBackToPrelim"
      type="is-blue"
      class="mt-6"
      @click="finishApplication"
      >{{ $t("af:application.closed.button.back_to_preliminary") }}</b-button
    >
  </div>
</template>

<script>
export default {
  name: "ApplicationFlowClosed",
  components: {
    ApplicationTemplate: () => import("@/components/ApplicationTemplate.vue"),
  },
  props: {},
  computed: {},
  methods: {
    async finishApplication() {
      try {
        await this.$store.dispatch("loanApplication/finish");
        await this.$store.dispatch("purchase/hasActivePurchase");
        await this.$router.push("/user/applications");
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
